'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from '../Link/Link';
import { styled } from '@mui/material/styles';
const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.tokens.FuelColorGray800,
    textDecorationColor: theme.tokens.FuelColorGray800,
    fontSize: theme.tokens.FuelFontSizeSm,
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.Mui-focusVisible': {
        boxShadow: `0 0 0 2px ${theme.tokens.FuelColorGray200}, 0 0 0 4px #1b1b1b`
    }
}));
export const FooterLink = React.forwardRef(({ text, ...props }, ref) => (_jsx(StyledLink, { ref: ref, ...props, children: text })));
FooterLink.displayName = 'FooterLink';
